import { motion } from "framer-motion";
import { ABOUT_IMAGE, CHURCH } from "@/lib/data";

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.8, ease: "easeOut" },
};

export default function About() {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="relative bg-[#050505] py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {/* Left column — image */}
          <motion.div
            {...fadeUp}
            className="lg:col-span-5 relative aspect-[4/5] overflow-hidden order-2 lg:order-1"
          >
            <img
              src={ABOUT_IMAGE}
              alt="Interior da igreja"
              className="absolute inset-0 w-full h-full object-cover scale-105 hover:scale-110 transition-transform duration-[1500ms]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
              <p className="text-[10px] tracking-overline uppercase text-[#D4AF37]">
                Desde {CHURCH.founded}
              </p>
              <div className="gold-divider" />
            </div>
          </motion.div>

          {/* Right column — text */}
          <div className="lg:col-span-7 order-1 lg:order-2">
            <motion.p
              {...fadeUp}
              className="text-xs tracking-overline uppercase text-[#D4AF37] mb-6"
            >
              Nossa História
            </motion.p>

            <motion.h2
              {...fadeUp}
              transition={{ ...fadeUp.transition, delay: 0.1 }}
              className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05] tracking-tight"
              data-testid="about-title"
            >
              Uma família brasileira <br />
              <span className="italic text-white/80">na América,</span>{" "}
              <span className="text-[#D4AF37]">enraizada</span> em Cristo.
            </motion.h2>

            <motion.div
              {...fadeUp}
              transition={{ ...fadeUp.transition, delay: 0.2 }}
              className="mt-10 space-y-6 text-white/70 leading-relaxed text-lg max-w-xl"
            >
              <p>
                Nascemos em <strong className="text-white">{CHURCH.founded}</strong>{" "}
                com o sonho de oferecer aos brasileiros que vivem nos Estados
                Unidos um lugar de fé, acolhimento e crescimento espiritual em
                nossa língua e cultura.
              </p>
              <p>
                Mais que uma igreja, somos uma família que caminha junto —
                celebrando, chorando, servindo e crescendo juntos no
                conhecimento de Jesus.
              </p>
            </motion.div>

            <motion.div
              {...fadeUp}
              transition={{ ...fadeUp.transition, delay: 0.3 }}
              className="mt-12 grid sm:grid-cols-2 gap-px bg-white/5"
              data-testid="mission-vision-grid"
            >
              <div className="bg-[#0A0A0A] p-8">
                <p className="text-[10px] tracking-overline uppercase text-[#D4AF37] mb-4">
                  Missão
                </p>
                <p className="font-serif-display text-2xl text-white leading-snug">
                  Proclamar o Evangelho à comunidade brasileira nos EUA,
                  oferecendo acolhimento, ensino bíblico e crescimento
                  espiritual.
                </p>
              </div>
              <div className="bg-[#0A0A0A] p-8">
                <p className="text-[10px] tracking-overline uppercase text-[#D4AF37] mb-4">
                  Visão
                </p>
                <p className="font-serif-display text-2xl text-white leading-snug">
                  Ser uma igreja sólida, fiel à Palavra — fortalecendo famílias,
                  formando discípulos e expandindo o Reino.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
